<template>
  <div class="container">

    <main-top step-number="3"/>

    <div class="main-content">

      <div class="row white-box">
        <div class="map-wrapper">
          <div class="search-wrapper">
            <input class="form-control" type="text" placeholder="请输入您的地址搜索附近的印箱" v-model="address">
            <span class="btn btn-search" v-on:click="searchNearby"><i class="icon-search-white"></i></span>
          </div>
          <div class="map" id="map">
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="lastTerminal && lastTerminal.namecode" class="map-info white fs12">
          <span class="fs14">上次打印设备</span>
          <span>类型：{{ lastTerminal.namecode }}</span>
          <span>位置：{{ lastTerminal.address }}</span>
          <i class="icon-site fr" v-on:click="position"></i>
        </div>
      </div>

    </div>

    <main-right/>

  </div>
</template>

<script>
  import {showModal, hideModal, ajax} from '@/api/global'
  import Cookies from 'js-cookie'
  import AMap from 'AMap'
  import AMapUI from 'AMapUI'

  import MainTop from '@/components/MainTop'
  import MainRight from '@/components/MainRight'

  export default {
    name: "PagePrintMap",
    components: {
      MainTop,
      MainRight
    },
    props: ['isLogin'],
    data: function () {
      return {
        address : '',
        lastTerminal : null,
        nearbyTerminal : null,
        map : null,
        markers : [],
        allPrints: []
      }
    },
    methods: {
      // 获取最后一次打印终端的信息
      ajaxLastTerInfo : function () {
        var self = this;
        ajax({
          url : 'api/app-service/getLastPrinter',
          type : 'get',
          success : function (res) {
            self.lastTerminal = res.data;
            console.info(self.lastTerminal);
          }
        });
      },
      // 点击定位最后一次打印终端地址
      position : function () {
        var self = this;
        if (!self.lastTerminal) return;
        self.map.remove(self.markers);
        self.markers.length = 0;
        var marker = new AMap.Marker({
          map: self.map,
          position: [self.lastTerminal.loc[0], self.lastTerminal.loc[1]]
        });
        var infoWindow = new AMap.InfoWindow({
          content: '类型：' + self.lastTerminal.namecode + '; 位置：' + self.lastTerminal.address,
          offset: {x: 0, y: -30}
        });
        marker.on("mouseover", function(e) {
          infoWindow.open(self.map, marker.getPosition());
        });
        self.map.setFitView();
        self.markers.push(marker);
      },
      search : function (lat, lng) {
        var self = this;
        console.info('local : ('+lat+','+lng+')');

        ajax({
          url : 'api/app-service/getNearPrinter',
          type : 'get',
          data : {
            position : lat+','+lng,
          },
          success : function (res) {
            self.nearbyTerminal = res.data;
            self.map.remove(self.markers);
            self.markers.length = 0;
            if (res.data.length) {
              console.info(res.data);
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].loc.length) {
                  (function (d) {
                    var position = [d.loc[0], d.loc[1]];
                    var content = '类型：' + d.namecode + '; 位置：' + d.address;
                    var marker = new AMap.Marker({
                      map: self.map,
                      position: position,
                      icon: new AMap.Icon({
                        size: new AMap.Size(80, 80),  //图标大小
                        image: "http://www.yinwow.com/mobile/images/icons/icon-map-marker.png",
                        imageOffset: new AMap.Pixel(0, 0)
                      })
                    });
                    var infoWindow = new AMap.InfoWindow({
                      content: content,
                      offset: {x: 5, y: 5}
                    });
                    marker.on("mouseover", function(e) {
                      infoWindow.open(self.map, marker.getPosition());
                    });
                    self.markers.push(marker);
                  })(res.data[i]);
                }
              }
              self.map.setFitView();
              console.info('markers : ');
              console.info(self.markers);
            } else {
              alert("附近没有印箱终端!");
            }
          },
          fail : function () {
            alert("附近没有印箱终端!");
          }
        });
      },
      // 搜索附近终端信息
      searchNearby : function () {
        var self = this;
        if (!self.address) {
          alert('请输入您的地址!');
          return false;
        }
        // 创建地址解析器实例
        AMap.service('AMap.Geocoder',function(){//回调函数
          //实例化Geocoder
          var geocoder = new AMap.Geocoder({
            // city: "010", //城市，默认：“全国”
            radius: 2 //范围，默认：500
          });
          //地理编码,返回地理编码结果
          geocoder.getLocation(self.address, function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              console.info(result);
              //地理编码结果数组
              var geocode = result.geocodes;
              if (geocode.length) {
                // for (var i = 0; i < geocode.length; i++) {}
                self.search(geocode[0].location.getLat(), geocode[0].location.getLng());
              } else{
                alert("您选择地址没有解析到结果!");
              }
            }else{
              alert("您选择地址没有解析到结果!");
            }
          });
        });
      },
      location : function () {
        var self = this;
        self.map.plugin('AMap.Geolocation', function() {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 10000,          //超过10秒后停止定位，默认：无穷大
            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            zoomToAccuracy: true,      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            buttonPosition:'RB'
          });
          self.map.addControl(geolocation);
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
          AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
        });
        //解析定位结果
        function onComplete(data) {
          var str=['定位成功'];
          str.push('经度：' + data.position.getLng());
          str.push('纬度：' + data.position.getLat());
          if(data.accuracy){
            str.push('精度：' + data.accuracy + ' 米');
          }//如为IP精确定位结果则没有精度信息
          str.push('是否经过偏移：' + (data.isConverted ? '是' : '否'));
          // 搜索附近终端
          self.search(data.position.getLat(), data.position.getLng());
        }
        //解析定位错误信息
        function onError(data) {
          console.info(' 获取当前定位失败 : ');
          console.info(data);
          alert('获取当前定位失败, 请稍后再试!');
        }
      },
      initMap : function () {
        var self = this;
        // 初始化地图
        self.map = new AMap.Map('map', {
          resizeEnable: true
        });
        //地图中添加地图操作ToolBar插件
        AMapUI.loadUI(['control/BasicControl'], function(BasicControl) {
          //缩放控件，显示Zoom值
          self.map.addControl(new BasicControl.Zoom({
            position: 'lb',
            showZoomNum: true
          }));
        });

        //地图添加现有设备定位
        ajax({
            url : 'api/app-service/getPrinter',
            type : 'get',
            data : {},
          success : function (res) {
            self.allPrints = res.data;
            console.info(self.allPrints);
          }
        });

        AMapUI.loadUI(['overlay/SimpleMarker'], function(SimpleMarker) {
          for (var i = 0; i < self.allPrints.length; i++) {
            var gpsPoint = self.allPrints[i].gpsPoint;
            if (gpsPoint == '' || gpsPoint == null) continue;
            var point = gpsPoint.split(",");
            var LatLng = [parseFloat(point[0]), parseFloat(point[1])]

            new SimpleMarker({
              iconLabel: self.allPrints[i].name,
              //自定义图标地址
              iconStyle: require('../assets/img/mark_open.png'),

              //设置基点偏移
              offset: new AMap.Pixel(-16, -40),

              map: self.map,

              showPositionPoint: true,
              position: LatLng,
              zIndex: 100
            });
          }
        });
        //定位
        self.location();
      }
    },
    created: function () {
      console.info('page-print-map-init');
      var self = this;
      self.ajaxLastTerInfo();
      setTimeout(function () {
        self.initMap();
      }, 1000);
      Cookies.set('imgurl', '');      // 进入地图页面之后,清空已上传记录的 imgurl
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PagePrintMap.vue